import { action, makeObservable, observable } from 'mobx';
import { applicationStore, notificationStore, popupStore } from '@pascal/pascal-core';
import { candyDataStore } from './candyDataStore';
import { soundService } from '../services';

class DoBetStore {
  activeButton = false;

  winAmount = '';

  constructor() {
    makeObservable(this, {
      activeButton: observable,
      winAmount: observable,
      setWinAmount: action.bound,
      setActiveButton: action.bound,
      handleDoBetResult: action.bound,
      // increaseDemoBalance: action.bound,
      // decreaseDemoBalance: action.bound,
    });
  }

  setActiveButton(activeButton) {
    this.activeButton = activeButton;
  }

  handleDoBetResult(doBetData, candiesBetData) {
    const { responseCode } = doBetData;
    const { isDemo } = applicationStore;
    if (isDemo) {
      //   this.decreaseDemoBalance(
      //     doBetData?.betData.reduce((acc, curr) => plus(acc, curr?.amount), 0)
      //   );
      doBetData?.betData.forEach((item) => {
        if (item?.amount) {
          popupStore.updateDemoBetsCount();
        }
      });
      //   betStore.updateLiveBets(doBetData);
    }
    soundService.playBetAccepted();
    candyDataStore.setReBetData(candiesBetData);
    new Array(3).fill(null).forEach(() => {
      notificationStore.setNotificationType({ responseCode });
    });
    // notificationStore.setNotificationType({ responseCode });
  }

  setWinAmount(winAmount) {
    this.winAmount = winAmount;
  }

  // increaseDemoBalance(amount) {
  //   const balance = plus(userInfoStore.balance, amount);
  //   userInfoStore.setDemoBalance(balance);
  // }
  //
  // decreaseDemoBalance(betAmount) {
  //   userInfoStore.setDemoBalance(minus(userInfoStore.balance, betAmount));
  // }
}

export const doBetStore = new DoBetStore();
